const e=async(e,t,n,r)=>{let{data:i}=await e.get(`/webhooks/${t}/${n}`,{params:r});return i};export{e as getWebhooks};
//# sourceMappingURL=get-webhooks.mjs.map